import React from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button, Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger, Text,
  useDisclosure
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import { activeStyle, hoverStyle, popoverMenuButtonStyles } from '../../../styles/theme/util/popoverMenuButtonStyles';
import SearchBlueprintType from '../../../types/SearchBlueprintType';

const ValueDropdown = ({
  searchBlueprint,
  filter,
  isDisabled
}) => {
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { idKey = 'value', labelKey = 'text' } = filter.property;

  const handleSelectChange = selected => {
    const newValue = filter
      .property
      .values
      .find(option => String(option[idKey]) === String(selected));

    dispatch(searchBlueprint.updateStagedFilter({
      value: newValue[idKey],
      text: newValue[labelKey]
    }));

    onClose();
  };

  return (
    <Box
      flex={1}
      position="relative"
    >
      <Popover
        isOpen={isOpen}
        maxW="100%"
        placement="bottom"
        variant="expand"
        onClose={onClose}
        onOpen={onOpen}
      >
        <PopoverTrigger>
          <Button
            _active={activeStyle}
            _hover={hoverStyle}
            isDisabled={isDisabled}
            style={popoverMenuButtonStyles}
            variant="unstyled"
          >
            {filter.text || <Text color={colors.greyScale['500']}>Value</Text>}
            {!isDisabled && <Icon as={FaChevronDown} boxSize={4} />}
          </Button>
        </PopoverTrigger>
        <PopoverContent maxH="400px" maxWidth="304px" overflowY="auto" width="100%">
          <PopoverBody p="10px">
            {filter.property.values.map(option => (
              <Box
                _hover={{
                  bgColor: colors.primaryScale['50'],
                  color: colors.primaryScale['600'],
                  cursor: 'pointer'
                }}
                borderRadius="md"
                color="greyScale.600"
                key={option[idKey]}
                overflow="hidden"
                padding="10px 14px"
                position="inherit"
                textAlign="left"
                textOverflow="ellipsis"
                textStyle="bodyMd500"
                value={option[idKey]}
                variant="unstyled"
                whiteSpace="nowrap"
                width="100%"
                onClick={() => handleSelectChange(option[idKey])}
              >
                {option[labelKey]}
              </Box>
            ))}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};

ValueDropdown.propTypes = {
  isDisabled: PropTypes.bool,
  filter: PropTypes.shape({
    text: PropTypes.string,
    property: PropTypes.shape({
      idKey: PropTypes.string,
      labelKey: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }),
  searchBlueprint: SearchBlueprintType
};

export default ValueDropdown;
